import { Component, Input, OnInit } from '@angular/core';

declare var bootstrap: any;

@Component({
  selector: 'app-software',
  templateUrl: './software.component.html',
  styleUrls: ['./software.component.css']
})
export class SoftwareComponent {
  @Input() dataSoft: any;
  data = [];

  constructor() {}

  openDialog(items = []): void {
    this.data = items;
    const modalElement = document.getElementById('softwareModal');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  }

}
